import axios from "config/@axios";
import i18next from "i18next";

import * as uiActions from "store/actions/uiActions";
import * as archivesActions from "pages/Archive/store/archivesActions";

export const OPEN_DETAILS = "archiveActions::openDetails";
export const CLOSE_DETAILS = "archiveActions::closeDetails";
export const OPEN_DELETE = "archiveActions::openDelete";
export const CLOSE_DELETE = "archiveActions::closeDelete";
export const DELETE_ARCHIVES = "archiveActions::deleteArchives";
export const DELETE_ARCHIVES_SUCCESS = "archiveActions::deleteArchivesSuccess";
export const DELETE_ARCHIVES_FAILED = "archiveActions::deleteArchivesFailed";
export const OPEN_DOWNLOAD = "archiveActions::openDownload";
export const CLOSE_DOWNLOAD = "archiveActions::closeDownload";
export const DOWNLOAD_ARCHIVES = "archiveActions::downloadArchives";
export const DOWNLOAD_ARCHIVES_SUCCESS =
  "archiveActions::downloadArchivesSuccess";
export const DOWNLOAD_ARCHIVES_FAILED =
  "archiveActions::downloadArchivesFailed";
export const SET_SEARCH_PARAMS = "archiveActions::setSearchParams";
export const SET_PAGE = "archiveActions::setPage";
export const RESET_FAILED = "archiveActions::resetFailed";

export const openDetails = id => {
  return {
    type: OPEN_DETAILS,
    payload: {
      id
    }
  };
};

export const closeDetails = () => {
  return {
    type: CLOSE_DETAILS
  };
};

export const openDelete = (id = null) => {
  return {
    type: OPEN_DELETE,
    payload: {
      id
    }
  };
};

export const closeDelete = () => {
  return {
    type: CLOSE_DELETE
  };
};

export const deleteArchives =
  (type = "delete", arr) =>
  (dispatch, getState) => {
    const state = getState();
    const domain = state.auth.user.email.split("@")[1];

    const obj = {
      domain,
      mail_id_list: arr.map(n => parseInt(n))
    };

    dispatch({
      type: DELETE_ARCHIVES
    });

    return axios
      .post(`archives/messages/${type}`, obj)
      .then(() => {
        dispatch({
          type: DELETE_ARCHIVES_SUCCESS
        });
        dispatch(
          uiActions.addSnackbar({
            message: i18next.t(`archive:${type}.success_message`)
          })
        );
        dispatch(archivesActions.fetchArchives());
      })
      .catch(err => {
        dispatch({
          type: DELETE_ARCHIVES_FAILED,
          payload: {
            errorMessage: err.errorMessage
          }
        });
      });
  };

export const openDownload = downloadType => {
  return {
    type: OPEN_DOWNLOAD,
    payload: {
      downloadType
    }
  };
};

export const closeDownload = () => {
  return {
    type: CLOSE_DOWNLOAD
  };
};

export const downloadArchives = data => dispatch => {
  dispatch({
    type: DOWNLOAD_ARCHIVES
  });

  return axios
    .post("archives/jobs", data)
    .then(() => {
      dispatch({
        type: DOWNLOAD_ARCHIVES_SUCCESS
      });
      dispatch(
        uiActions.addSnackbar({
          message: i18next.t("archive:download.success_message")
        })
      );
    })
    .catch(err => {
      dispatch({
        type: DOWNLOAD_ARCHIVES_FAILED,
        payload: {
          errorMessage: err.errorMessage
        }
      });
    });
};

export const setSearchParams = params => {
  return {
    type: SET_SEARCH_PARAMS,
    payload: {
      searchParams: params
    }
  };
};

export const setPage = page => {
  return {
    type: SET_PAGE,
    payload: {
      page
    }
  };
};

export const resetFailed = () => {
  return {
    type: RESET_FAILED
  };
};
